/**
 * D62 — a persona keeps ONE launch per day: the newest.
 *
 * A new launch erases the previous one's sub-runs, transcripts, extras and day rows (the
 * rollup Lambda does it at launch-complete). The credits the erased launch spent are NOT
 * refunded, which is why every « lancer » path asks first.
 *
 * The day comparison is UTC on purpose: the server derives the day from
 * `launchTs(launchId)`, so a local-time day would disagree with the very rule this warns
 * about for anyone either side of midnight UTC.
 */
export function hasLaunchToday(lastLaunchAt?: string): boolean {
  if (!lastLaunchAt) return false;
  return lastLaunchAt.slice(0, 10) === new Date().toISOString().slice(0, 10);
}
